export const initialState = { message: "", type: "", showError: false };
export const errorState = {
  message: "An unexpected error has occurred",
  type: "danger",
  showError: true,
};
